
import Router from 'vue-router'
import List from '../pages/vocational/List.vue'

import store from "../store/index.js";
import Landing from "../pages/common-apps/Landing.vue";

const baseRoutes = [
  {
    path: '/',
    redirect: { name: 'Landing' }
  },
  {
    path: '/landing',
    name: 'Landing',
    component: Landing,
    meta: { bodyClass: 'landing-page' }
  }
] // to comment Landing route when using on dev mode

const vocationalRoutes = [
  {
    path: '/list',
    name: 'Ticket List',
    component: List,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: `/list/filter/:status`,
    name: 'Ticket Filter By Status',
    component: () => import(/* webpackChunkName: "article" */ "../pages/vocational/List.vue"),
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: `/list/search/:type/:term`,
    name: 'Ticket Search',
    component: () => import(/* webpackChunkName: "article" */ "../pages/vocational/List.vue"),
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/list/:id',
    name: 'Ticket Details',
    component: () => import(/* webpackChunkName: "ticket2details" */ "../pages/vocational/TicketDetails.vue"),
    // component: TicketDetails,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
]

const routes = baseRoutes.concat(vocationalRoutes)



const routerVocational = new Router({
  routes,
  mode: 'history',
  base: 'voc'
})

routerVocational.beforeEach((to, from, next) => {
  // vueBodyClass.guard(to, next)
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters['account/isAuthenticated']) {
      next()
      return
    }
    next('/landing')
  } else {
    next()
  }
})

export default routerVocational